import classNames from 'classnames'
import Link from 'next/link'
import { useContext } from 'react'
import { useMediaQuery } from 'react-responsive'
import DefaultLogo from '@/assets/images/bi_default.svg'
import DefaultWhiteLogo from '@/assets/images/bi_default_white.svg'
import { CONTACT_PATH, DRIVER_EVENT, HOME_PATH, OWNER_EVENT, SERVICE_PATH, CAREER_PATH } from '@/constants/routes'
import { ResponsiveMenu } from '@/features/common/components'
import { useCustomMediaQuery } from '@/features/common/hooks/useCustomMediaQuery'
import { useCustomRouter } from '@/features/common/hooks/useCustomRouter'
import { useHeaderHandler } from '@/features/common/hooks/useHeaderHandler'
import { useScrollDirection } from '@/features/common/hooks/useScrollDirection'
import { EventContext } from '@/providers/EventProvider'
import { sendCustomEvent } from '@/utils/GTM'

function Header() {
  const { isChangeColor, isMouseOver, handleMouseOver, handleMouseOut } = useHeaderHandler()
  const isMobile = useMediaQuery({ minWidth: 1193 })
  const { handlePush } = useCustomRouter()
  const { UpToTablet, Mobile } = useCustomMediaQuery()
  const { scrollDirection } = useScrollDirection()
  const { isShowPage } = useContext(EventContext)

  const handleGoHome = () => {
    sendCustomEvent({ event: 'click', category: '내부 링크 이동 클릭', label: '홈으로 이동' })
    handlePush(HOME_PATH).catch()
  }

  const handleRoute = (url: string) => {
    let label: string

    if (url.includes('login')) {
      label = '메뉴 - 화주 로그인'
    } else if (url.includes('registration')) {
      label = '메뉴 - 화주 회원가입'
    } else if (url.includes('contact')) {
      label = '메뉴 - 운송문의'
    } else if (url.includes('service')) {
      label = '메뉴 - 서비스 소개'
    } else if (url.includes(OWNER_EVENT)) {
      label = '메뉴 - 화주 이벤트'
    } else if (url.includes(DRIVER_EVENT)) {
      label = '메뉴 - 차주 이벤트'
    } else if (url.includes(CAREER_PATH)) {
      label = '메뉴 - 채용 사이트'
    } else {
      label = ''
    }

    sendCustomEvent({ event: 'click', category: '메뉴 링크 클릭', label })
  }

  return (
    <header
      className={classNames('header-navigation-wrapper', {
        transparent: isMobile && isChangeColor,
        hideHeader: scrollDirection === 'down' && isMobile,
      })}
    >
      <div className='container'>
        <h1 title='더 운반' onClick={handleGoHome}>
          {isMobile && isChangeColor ? <DefaultWhiteLogo /> : <DefaultLogo />}
        </h1>

        {/* Desktop, Tablet의 경우 */}
        <UpToTablet>
          <nav className='header__nav'>
            <div
              className='header__nav__event'
              onFocus={handleMouseOver}
              onMouseOver={handleMouseOver}
              onBlur={handleMouseOut}
              onMouseOut={handleMouseOut}
            >
              {isShowPage && (
                <>
                  <p>이벤트</p>
                  {isMouseOver && (
                    <div className='header__nav__event__link'>
                      <Link onClick={() => handleRoute(OWNER_EVENT)} href={OWNER_EVENT}>
                        화주 이벤트
                      </Link>
                      <Link onClick={() => handleRoute(DRIVER_EVENT)} href={DRIVER_EVENT}>
                        차주 이벤트
                      </Link>
                    </div>
                  )}
                </>
              )}
            </div>

            <Link onClick={() => handleRoute(SERVICE_PATH)} href={SERVICE_PATH}>
              서비스 소개
            </Link>
            <Link onClick={() => handleRoute(CONTACT_PATH)} href={CONTACT_PATH}>
              운송문의
            </Link>
            <Link
              onClick={() => handleRoute(`${process.env.NEXT_PUBLIC_OWNER_URL}/account/registration`)}
              href={`${process.env.NEXT_PUBLIC_OWNER_URL}/account/registration`}
              target='_blank'
            >
              회원가입
            </Link>
            <Link
              onClick={() => handleRoute(`${process.env.NEXT_PUBLIC_OWNER_URL}/login`)}
              href={`${process.env.NEXT_PUBLIC_OWNER_URL}/login`}
              target='_blank'
            >
              로그인
            </Link>
            {/* 검색결과노출을 위해 미노출 링크 등록 */}
            <Link
              onClick={() => handleRoute(CAREER_PATH)}
              href={CAREER_PATH}
              target='_blank'
              style={{ display: 'none' }}
            >
              채용
            </Link>
          </nav>
        </UpToTablet>
        {/* Mobile 의 경우 */}
        <Mobile>
          <ResponsiveMenu />
        </Mobile>
      </div>
    </header>
  )
}

export default Header
